import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Config from './Config';

function ResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [tokenValid, setTokenValid] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const { api_url } = Config;

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                setTokenValid(false);
                setError('Invalid reset link.');
                return;
            }
            try {
                const formData = new FormData();
                formData.append('code', token);
                const response = await fetch(`${api_url}/ws-verify-reset-token`, {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.json();
                if (data.success) {
                    setTokenValid(true);
                } else {
                    setTokenValid(false);
                    setError(data.message || 'Invalid or expired reset link.');
                }
            } catch {
                setTokenValid(false);
                setError('Unable to verify reset link.');
            }
        };
        verifyToken();
    }, [token, api_url]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        if (!password || !confirmPassword) {
            setError('Please enter and confirm your new password');
            return;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        if (password.length < 6) {
            setError('Password must be at least 6 characters');
            return;
        }
        setSubmitting(true);
        try {
            const formData = new FormData();
            formData.append('code', token);
            formData.append('password', password);
            formData.append('confirm_password', confirmPassword);
            const response = await fetch(`${api_url}/ws-reset-password`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (!response.ok || !data.success) {
                setError(data.message || 'Failed to reset password');
                return;
            }
            setSuccess(data.message);
            setTimeout(() => navigate('/login'), 2000);
        } catch {
            setError('Failed to reset password. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="login-body d-flex flex-column h-100">
            <div className="login-container">
                <div className="login-content">
                    <div className="login-content_header">
                        <span className="logo">
                            <img src="/assets/img/logo1.jpg" alt="Star Pacific Logo" />
                        </span>
                        <p>Reset your password</p>
                    </div>
                    <div style={{ float: 'left', width: '100%' }}>
                        {tokenValid === false && (
                            <div className="login-networks">
                                <p className="text-danger">{error}</p>
                                <p><Link to="/forgot-password">Request a new reset link</Link></p>
                                <p><Link to="/login">Back to login</Link></p>
                            </div>
                        )}
                        {tokenValid === true && (
                            <form className="login-form" onSubmit={handleSubmit}>
                                <input
                                    type="password"
                                    placeholder="New password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoComplete="new-password"
                                />
                                <input
                                    type="password"
                                    placeholder="Confirm new password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    autoComplete="new-password"
                                />
                                {error && <p className="text-danger">{error}</p>}
                                {success && <p className="text-success">{success}</p>}
                                <button type="submit" className="login-submit-btn" disabled={submitting}>
                                    {submitting ? 'Updating...' : 'Update password'}
                                </button>
                            </form>
                        )}
                        {tokenValid === true && (
                            <div className="login-networks">
                                <p><Link to="/login">Back to login</Link></p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
